import React from 'react';
import { cn } from '@/lib/utils';

interface GoalProgressBarProps {
  completedTasks: number;
  totalTasks: number;
  className?: string;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export const GoalProgressBar: React.FC<GoalProgressBarProps> = ({
  completedTasks,
  totalTasks,
  className,
  showLabel = true,
  size = 'sm'
}) => {
  const percentage = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
  const isComplete = percentage === 100;

  const barHeight = size === 'sm' ? 'h-1.5' : 'h-2';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div className={cn('w-full', className)}>
      {showLabel && (
        <div className={cn('flex justify-between items-center mb-1', textSize)}>
          <span className="text-muted-foreground">
            {completedTasks}/{totalTasks} tasks
          </span>
          <span className={cn(
            'font-medium',
            isComplete ? 'text-green-600' : 'text-muted-foreground'
          )}>
            {percentage}%
          </span>
        </div>
      )}
      <div className={cn('w-full bg-gray-200 rounded-full overflow-hidden', barHeight)}>
        <div
          className={cn(
            'h-full rounded-full transition-all duration-300',
            isComplete ? 'bg-green-500' : 'bg-primary'
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
};

export default GoalProgressBar;
